import { render } from "./download.vue?vue&type=template&id=add35cae&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=add35cae&scoped=true&lang=css"

import exportComponent from "F:\\Vuedemo\\element-便签\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add35cae"]])

export default __exports__